import debounce from 'lodash/debounce';
import handleClickOutside from '../common/handleClickOutside';
import handleEventMap from '../common/handleEventMap';
import handleToggle from '../common/handleToggle';
import handleMultiSelectChange from './handleMultiSelectChange';
import handleMultiSelectClose from './handleMultiSelectClose';
import handleMultiSelection from './handleMultiSelection';
import handleSingleSelection from './handleSingleSelection';
import { handleFlyoutClose } from '../filter-flyout/handleFlyout';

/**
 * Attach interactions to every element that matches selector.
 */
$('.select').each((_, select) => {
    // cache placeholder
    const placeholder = $(select).find('.select__head__label').text();
    $(select).attr('data-placeholder', placeholder);

    // set selection handling to single or multi
    const isSingleSelect = $(select).attr('data-single-select') === 'true';
    const hasFlyoutAttached = select.hasAttribute('data-filterKey');
    const handleSelection = isSingleSelect
        ? handleSingleSelection
        : handleMultiSelection;

    if (isSingleSelect) {
        $(select)
            .on('change', 'input', handleSelection(select))
            .on('change', 'input', debounce(handleToggle(select, false), 200))
            .on('change', 'input', handleEventMap(select, 'select:change'));
        if (hasFlyoutAttached) {
            $(select).on('change', () => { handleFlyoutClose(); });
        }
    } else {
        $(select)
            .on('select:reset', handleMultiSelectChange(select))
            .on('click', '.select__head, .select__footer, .flyout--addFilter', handleMultiSelectClose(select));
        $(document).on('click', handleClickOutside(select, handleMultiSelectClose(select)));
    }

    $(select).on('click', '.select__head, .select__footer, .flyout--addFilter', handleToggle(select));
    $(document).on('click', handleClickOutside(select, handleToggle(select, false)));

    $(window)
        .on('load', handleSelection(select))
        .on('load', () => {
            // add nice custom scrollbar
            const bodySelect = $(select).find('.select__body');
            if (bodySelect.length) {
                bodySelect.niceScroll({
                    // set values intentionally to invalid values
                    // in order to make our custom css work
                    cursorcolor: 'null',
                    cursorwidth: 'null',
                    cursorborder: 'null',
                    cursorborderradius: 'null',
                    cursoropacitymin: 1,
                    // this padding would be correct by design,
                    // but breaks scrolling to the bottom
                    // railpadding: { top: 10, right: 10, bottom: 10 },
                });
            }
        });
});



// WEBPACK FOOTER //
// ./src/scripts/components/select/index.js